<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="h-100p overflow-y-scroll w-100 pan-result-main">
        <div class="custom_container pan-result-layout">
            <div class="search-container">
                <!-- Top bar -->
                <div class="search-header">
                    <div class="header-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="bi bi-arrow-left"></i>
                            <span>Back</span>
                        </button>
                    </div>
                    <div class="header-center">
                        <h1 class="search-query">{{panData?.pan_number || selectedSearchResult?.searched_pan || '-'}}</h1>
                    </div>
                    <!-- <div class="header-right">
                 
                        <div class="search-box">
                            <input class="search-input" type="text" placeholder="Search here" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" />
                        </div>
                    </div> -->
                </div>

                <!-- Loader -->
                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <!-- Search Results -->
                <div class="container container--pan-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && panData">
                    <div class="main-pan-details-wrapper">
                        <!-- <div class="d-flex justify-content-between align-items-center header-section">
                    <div class="text-start pan-header-info">
                        <div class="pan-number-display">{{panData?.pan_number || '-'}}</div>
                        <div class="pan-name-display">{{panData?.full_name || '-'}}</div>
                    </div>
                    <div class="active-badge">
                        <i class="bi bi-person-badge"></i>
                        <span>{{panData?.category || 'Person'}}</span>
                    </div>
                </div> -->

                        <div class="row g-3 quick-info-row">
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-gender">
                                    <div class="info-card-icon">
                                        <i class="bi bi-gender-ambiguous"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Gender</div>
                                        <h4 class="my-2">{{panData?.gender || '-'}}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-dob">
                                    <div class="info-card-icon">
                                        <i class="bi bi-calendar-event"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Date of Birth</div>
                                        <h4 class="my-2">{{formatDate(panData?.dob)}}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-aadhaar">
                                    <div class="info-card-icon">
                                        <i class="bi bi-shield-check"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Aadhaar Linked</div>
                                        <h4 class="my-2">
                                            <span [class]="panData?.aadhaar_linked ? 'status-yes' : 'status-no'">
                                                {{panData?.aadhaar_linked ? 'Yes' : 'No'}}
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-masked">
                                    <div class="info-card-icon">
                                        <i class="bi bi-eye-slash"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Masked Aadhaar</div>
                                        <h4 class="my-2">{{panData?.masked_aadhaar || '-'}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box personal-details-box">
                            <h5 class="details-heading"><i class="bi bi-person-vcard"></i>Personal Details</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Full Name</p>
                                        <p>{{panData?.full_name || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">PAN Number</p>
                                        <p>{{panData?.pan_number || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Date of Birth</p>
                                        <p>{{formatDate(panData?.dob) || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Gender</p>
                                        <p>{{panData?.gender || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Email</p>
                                        <p>
                                            <span *ngIf="panData?.email; else noEmail">
                                                <a [href]="'mailto:' + panData.email" class="text-primary">{{panData.email}}</a>
                                            </span>
                                            <ng-template #noEmail>-</ng-template>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Phone Number</p>
                                        <p>
                                            <span *ngIf="panData?.phone_number; else noPhone">
                                                <a [href]="'tel:' + panData.phone_number" class="text-primary">{{panData.phone_number}}</a>
                                            </span>
                                            <ng-template #noPhone>-</ng-template>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box address-details-box mt-3" *ngIf="panData?.address">
                            <h5 class="details-heading"><i class="bi bi-geo-alt"></i>Address Details</h5>
                            <div class="row" *ngIf="panData?.address?.full">
                                <div class="col-12">
                                    <div class="detail-row">
                                        <p class="detail-label">Full Address</p>
                                        <p>{{panData?.address?.full || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Address Line 1</p>
                                        <p>{{panData?.address?.line_1 || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Address Line 2</p>
                                        <p>{{panData?.address?.line_2 || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Street Name</p>
                                        <p>{{panData?.address?.street_name || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">City</p>
                                        <p>{{panData?.address?.city || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">State</p>
                                        <p>{{panData?.address?.state || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">ZIP/Pincode</p>
                                        <p class="fw-bold">{{panData?.address?.zip || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Country</p>
                                        <p>{{panData?.address?.country || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box verification-status-box mt-3">
                            <h5 class="details-heading"><i class="bi bi-patch-check"></i>Verification & Status</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Aadhaar Linked</p>
                                        <p>
                                            <span [class]="panData?.aadhaar_linked ? 'badge badge-success' : 'badge badge-warning'">
                                                {{panData?.aadhaar_linked ? 'Yes' : 'No'}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Masked Aadhaar</p>
                                        <p>{{panData?.masked_aadhaar || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">DOB Check</p>
                                        <p>
                                            <span [class]="panData?.dob_check ? 'badge badge-success' : 'badge badge-warning'">
                                                {{panData?.dob_check !== null && panData?.dob_check !== undefined ? (panData?.dob_check ? 'Yes' :
                    'No') : '-'}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">DOB Verified</p>
                                        <p>
                                            <span [class]="panData?.dob_verified ? 'badge badge-success' : 'badge badge-warning'">
                                                {{panData?.dob_verified !== null && panData?.dob_verified !== undefined ? (panData?.dob_verified ?
                    'Yes' : 'No') : '-'}}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Category</p>
                                        <p class="text-capitalize">{{panData?.category || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Less Info</p>
                                        <p>
                                            <span [class]="panData?.less_info ? 'badge badge-success' : 'badge badge-warning'">
                                                {{panData?.less_info !== null && panData?.less_info !== undefined ? (panData?.less_info ? 'Yes' :
                    'No') : '-'}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="detail-row mt-3" *ngIf="panData?.input_dob">
                                        <p class="detail-label">Input DOB</p>
                                        <p>{{formatDate(panData?.input_dob) || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3" *ngIf="panData?.client_id">
                                        <p class="detail-label">Client ID</p>
                                        <p class="text-muted small">{{panData?.client_id || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="details-box mt-3" *ngIf="selectedSearchResult">
                            <h5 class="details-heading">Search Metadata</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Result ID</p>
                                        <p class="text-muted small">{{selectedSearchResult?.result_id || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">PAN Search ID</p>
                                        <p class="text-muted small">{{selectedSearchResult?.pan_search_id || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Created On</p>
                                        <p>{{selectedSearchResult?.created_on ? formatDateTime(selectedSearchResult?.created_on) : '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Updated On</p>
                                        <p>{{selectedSearchResult?.updated_on ? formatDateTime(selectedSearchResult?.updated_on) : '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="notes-section mt-3">
                            <div class="notes-header">
                                <i class="bi bi-journal-text"></i>
                                <span>Add Notes</span>
                            </div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{notes.length}}/300</span>
                                    <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">
                                        Update Notes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>